<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<h1 class="toc-title">CONTENTS</h1>
<h2 class="toc1"><a href="#/xhtml/04_Acknowledgements">Acknowledgements</a></h2>
<h2 class="toc3"><a href="#/xhtml/05_Introduction">Introduction – The Invasion of the Philippines</a></h2>
<h2 class="toc"><span href="#/xhtml/06_Chapter01" title="Link target outside of Sample"><span class="space">Chapter 1</span> The Leyte Landings</span></h2>
<h2 class="toc"><span href="#/xhtml/07_Chapter02" title="Link target outside of Sample"><span class="space">Chapter 2</span> The Japanese Naval Forces</span></h2>
<h2 class="toc"><span href="#/xhtml/08_Chapter03" title="Link target outside of Sample"><span class="space">Chapter 3</span> Battle of the Sibuyan Sea: 24 October 1944</span></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter04" title="Link target outside of Sample"><span class="space">Chapter 4</span> Battles of the Sulu Sea and the Surigao Strait: 24-25 October 1944</span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter05" title="Link target outside of Sample"><span class="space">Chapter 5</span> The Battle off Samar: 25 October 1944</span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter06" title="Link target outside of Sample"><span class="space">Chapter 6</span> Battle off Cape Engaño: 25-26 October 1944</span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter07" title="Link target outside of Sample"><span class="space">Chapter 7</span> Consequences and Controversies</span></h2>
<h2 class="toc2"><span href="#/xhtml/13_References" title="Link target outside of Sample">References and Notes</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?3fbbb006